var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTenant(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 80,
    viewBox: "0 0 36 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.50837 49.0807L1.50865 49.0784L2.7492 38.8196C2.74925 38.8192 2.7493 38.8188 2.74935 38.8184C3.43512 33.233 8.09076 29.0859 13.512 29.0859H22.1968H22.1971C27.6197 29.0859 32.2748 33.2335 32.9611 38.8199L32.9623 38.8295L32.9636 38.8391L34.3574 49.088C34.4067 49.5277 34.0459 50.109 33.5046 50.2732C32.6191 50.4236 31.7086 50.5779 30.7979 50.7323C29.8546 50.8922 28.911 51.0522 27.9945 51.2078L26.8175 51.4078L26.7482 52.5996L25.3538 76.5773C25.2551 77.6919 24.3524 78.5001 23.2833 78.5001H12.5817C11.5128 78.5001 10.6097 77.691 10.5112 76.5773L9.11677 52.5996L9.04746 51.4077L7.87048 51.2078C7.15767 51.0868 6.49352 50.9934 5.8543 50.9035C4.66955 50.7368 3.57046 50.5823 2.40595 50.2859L2.38603 50.2808L2.36597 50.2763C1.76363 50.1405 1.44192 49.6233 1.50837 49.0807Z",
    stroke: "#585858",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.341 12.4139C29.341 18.4412 24.4555 23.3277 18.4271 23.3277C12.3999 23.3277 7.51328 18.4412 7.51328 12.4139C7.51328 6.3855 12.3998 1.5 18.4271 1.5C24.4556 1.5 29.341 6.38541 29.341 12.4139Z",
    stroke: "#585858",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTenant);
export default __webpack_public_path__ + "static/media/tenant.78342f0b72ded15c94eb7a0dadc7a2ad.svg";
export { ForwardRef as ReactComponent };